import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import styles from "./style.module.css";
import RegFont from "../RegFont";
/**
 * Single accordeon component
 */
const CustomAccordion = ({ children, title, extraClassName }) => {
    const [opened, setOpened] = useState(false);
    return (_jsxs(Accordion, { expanded: opened, onChange: (e, expanded) => setOpened(expanded), classes: { root: `${styles.accordion_root} ${extraClassName || ""}` }, children: [_jsx(AccordionSummary, { classes: { root: styles.accordion_summary }, expandIcon: opened ? _jsx(Remove, {}) : _jsx(Add, {}), children: _jsx(RegFont, { children: title }) }), _jsx(AccordionDetails, { children: children })] }));
};
export default CustomAccordion;
